import { render, staticRenderFns } from "./DeliveryDetailItem.vue?vue&type=template&id=3e21335c&scoped=true&"
import script from "./DeliveryDetailItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailItem.vue?vue&type=style&index=0&id=3e21335c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21335c",
  null
  
)

export default component.exports